module.exports = __webpack_public_path__ + "img/7.cc2b1461.jpg";